export const environment = {
    production: false,
    archivo: 'devsismedical.net/api/dicom-viewers?path=',
    baseEndpoint: ' devsismedical.net/api',
    endpoint: 'devsismedical.net/api/image-patient-details',
};